// extracted by mini-css-extract-plugin
module.exports = {"total":"OrderSummary-styles-module--total--LaQ_d"};